// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import common from './api/common'
import {post,get,patch} from './api/axios'
import * as filter from './api/filter'
import directive from './api/directive'
import Messages from './api/message'
import { overallCallWebRtc } from './api/utils'

import Viewer from "v-viewer"// 图片预览
import "viewerjs/dist/viewer.css"// 图片预览
Vue.use(Viewer)
Viewer.setDefaults({
 defaultOptions: {
    zIndex: 9999
  },
  Options: {
    "inline": true,
    "button": true,
    "navbar": false,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
})

//引用第三方样式
import 'element-ui/lib/theme-chalk/index.css'
import './assets/element/element.css'
import './assets/fxn/fxn.css'
import './assets/fxn/common.css'
import './assets/fxn/style.css'
import './assets/fxn/iconfont.css'

Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(require('vue-wechat-title'))
Vue.prototype.axios = axios
Vue.prototype.post=post;
Vue.prototype.get=get;
Vue.prototype.$callWebRtc = overallCallWebRtc;
Vue.prototype.$http=axios;
Vue.prototype.common = common
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$message = Messages

Vue.prototype.token = JSON.parse(localStorage.getItem('token'));

let OpenAside = new Vue()
Vue.prototype.OpenAside = OpenAside

//全局过滤器
Object.keys(filter).forEach(key => { 
  Vue.filter(key, filter[key]) 
})

//全局指令
Object.keys(directive).forEach(key =>{
  Vue.directive(key, directive[key])
})

//配置模板导入/导出的URL地址---银行端

// Vue.prototype.TextUrl = 'http://192.168.18.29/somebank_news/'
// axios.defaults.baseURL = 'http://192.168.18.29/somebank_news/'

//配置模板导入/导出的URL地址---本地

// Vue.prototype.WebSocketUrl = 'ws://120.78.2.162:2355'
// Vue.prototype.TextUrl = 'https://xinge_api.xingeguanli.com/'
// axios.defaults.baseURL = 'https://xinge_api.xingeguanli.com/'

//配置模板导入/导出的URL地址---正式

// Vue.prototype.WebSocketUrl = 'wss://ws.xingeguanli.com:2345'
// Vue.prototype.TextUrl = 'https://static.xingeguanli.com/'
// axios.defaults.baseURL = 'https://server.xingeguanli.com/'

//鸿特 正式
Vue.prototype.WebSocketUrl = 'wss://zcapi.tuandai.com:2345'
Vue.prototype.TextUrl = 'https://zcapi.tuandai.com/'
axios.defaults.baseURL = 'https://csapi.tuandai.com/'
Vue.prototype.webUrl = 'https://cs.tuandai.com/'

//鸿特 本地
// Vue.prototype.WebSocketUrl = 'ws://47.107.89.244:2345'
// Vue.prototype.TextUrl = 'http://47.107.89.244:8080/'
// axios.defaults.baseURL = 'http://120.79.85.197:8080/'

//鸿特 测试
// Vue.prototype.WebSocketUrl = 'wss://hongte.amcmj.com:2345'
// Vue.prototype.TextUrl = 'https://hongte.amcmj.com/'
// axios.defaults.baseURL = 'https://hongte.amcmj.com/'
// Vue.prototype.webUrl = 'https://hongte_cs.amcmj.com/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js